/* @flow */

import type { JSON } from 'common/types';

export default function nullable<V>(extract: JSON => V): JSON => V | null {
  return json => {
    if (json === null || typeof json === 'undefined') {
      return null;
    }
    return extract(json);
  };
}
